import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dualq_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export function saveAuth({ token, user }) {
  localStorage.setItem("dualq_token", token);
  localStorage.setItem("dualq_user", JSON.stringify(user));
}
export function getUser() {
  try { return JSON.parse(localStorage.getItem("dualq_user") || "null"); } catch { return null; }
}
export function clearAuth() {
  localStorage.removeItem("dualq_token");
  localStorage.removeItem("dualq_user");
}
export function isAuthed() { return !!localStorage.getItem("dualq_token"); }
